export const getNcsNotifications = (state) => {
  return (state.ncs.notifications && state.ncs.notifications.data) || [];
};
